export default __webpack_public_path__ + "static/media/showerbasebefore.f7e1db56.jpg";